import React from 'react';
import './card.css';

const CardPrimaryText = ({ children }) => {
  return (
    <span className='cardPrimaryText'>{children}</span>
  )
}

export default CardPrimaryText